import Vue from 'vue';
import Router from 'vue-router';
import axios from '@/utils/request.js';
import store from '@/store/index.js';
import login from '../views/login/index.vue';
import views from '../views/view.route';
import notFound from "../views/404/index.route.js";

Vue.use(Router);

const routes = [...views, ...notFound, {
  path: '/login',
  component: login,
  meta: {
    noLimit: true
  }
}, {
  path: '*',
  redirect: '/404',
  meta: {
    noLimit: true
  }
}];

const controlPath = function (to, from, next) {
  if (to.path == '/index') {
    let path = '/no-root';
    if (store.getters.menuList[0]) {
      if (store.getters.menuList[0].children.length > 0) {
        path = store.getters.menuList[0].children[0].url;
        if (store.getters.menuList[0].children[0].children.length > 0) {
          path = store.getters.menuList[0].children[0].children[0].url;
        }
      } else {
        path = store.getters.menuList[0].url;
      }
    }
    if (path == '/index') {
      return next();
    }
    return next(path || '/no-root');
  }
  if (!to.meta.code) {
    return next();
  }
  return next();
};

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
});
router.beforeEach((to, from, next) => {
  if (to.meta.noLimit) {
    return next();
  }
  if (!localStorage.getItem('userToken')) {
    return next('/login');
  }
  axios({
    url: '/user/checkLogin.htm',
    method: 'POST',
    catchErrBySelf: true
  }).then(res => {
    if (store.getters.menuList.length == 0) {
      store.dispatch('buildMenu').then(() => {
        controlPath(to, from, next);
      });
    } else {
      controlPath(to, from, next);
    }
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js